import { compose } from '@beef/utils';
import { Button } from '@carnica/ui-kit';
import { withDataConverter } from '@beef/react';
import { ymPushParams } from "../../../../../../../../../utils/ym.alternative";
import { getWindow } from "../../../../../../../../../utils/window";
import { getAccountType } from "../../../../../../../../../utils/analytics";
import { getAnalyticsConverter } from "./analytics";
var analyticsConverter = getAnalyticsConverter({
  getWindow: getWindow,
  getAccountType: getAccountType,
  ymPushParams: ymPushParams
});
export var ButtonWithAnalytics = compose(withDataConverter(analyticsConverter))(Button);